<template>
  <div class="mask-box">
    <div class="bg-box">
      <div class="close" @click="close"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close () {
      this.$emit('close')
    },
    prefn() {}
  }
}
</script>

<style lang="scss">
@import "@/assets/mask.scss";
</style>